<template>
  <v-container
    :class="[equipmentResolution ? $vuetify.breakpoint.xsOnly ? 'pa-3 ma-0' :'pa-4 ma-0' : 'pa-0 mb-4' ]"
  >
    <v-card :dense="$vuetify.breakpoint.smAndDown">
      <v-card-title primary-title class="indigo white--text title">
        <v-flex pl-5>
          <p class="mb-1">{{ $t('equipment.addWorkRequests.title') }}</p>
        </v-flex>
      </v-card-title>
      <v-card-text class="pt-1" :class="[$vuetify.breakpoint.xsOnly ? 'pb-0' : 'pa-0']">
        <v-form v-model="form">
          <v-layout
            v-if="!equipmentResolution"
            :class="{'column reverse' : $vuetify.breakpoint.xsOnly}"
          >
            <v-flex xs12 offset-sm3 sm5>
              <v-autocomplete
                v-if="allEquip"
                v-model="equipmentIdLocal"
                :items="allEquipment"
                :label="$t('equipment.addWorkRequests.equipment')"
                item-text="Name"
                item-value="EquipmentId"
                :rules="[rules.required]"
              ></v-autocomplete>
              <v-autocomplete
                v-else
                :loading="loading"
                v-model="equipmentIdLocal"
                :search-input.sync="search"
                :items="allEquipment"
                :label="$t('equipment.addWorkRequests.equipmentWithSearch')"
                item-text="Name"
                item-value="EquipmentId"
                :rules="[rules.required]"
              >
                <template
                  slot="selection"
                  slot-scope="data"
                >{{data.item.Name}} {{data.item.ResponsibleName}}</template>
                <template slot="item" slot-scope="data">
                  <v-list-tile-content>
                    <v-list-tile-title v-html="data.item.Name"></v-list-tile-title>
                    <v-list-tile-sub-title v-html="data.item.ResponsibleName"></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex :class="[$vuetify.breakpoint.xsOnly ? 'ma-0 pa-0' : 'pl-3']">
              <v-checkbox
                class="pb-0 mb-0"
                v-model="allEquip"
                :label="$t('equipment.addWorkRequests.myEquipment')"
              ></v-checkbox>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex
              :class="[$vuetify.breakpoint.xsOnly ? 'd-block mt-3' : 'd-inline-flex']"
              offset-sm1
              sm10
            >
              <v-flex v-if="directionItems">
                <v-select
                  v-model="direction"
                  :items="directionItems"
                  :label="$t('equipment.addWorkRequests.direction')"
                  item-text="Name"
                  item-value="Code"
                  :class="{'pa-0 ma-0' : $vuetify.breakpoint.xsOnly}"
                  :rules="[rules.required]"
                >
                   <template slot="selection" slot-scope="data">
                    <span>{{ data.item.Name }}</span>
                  </template>
                  <template slot="item" slot-scope="data" >
                    <div v-if="!$vuetify.breakpoint.xsOnly">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }" >
                          <span dark v-on="on">{{ data.item.Name }}</span>
                        </template>
                        <span>{{data.item.Description}}</span>
                      </v-tooltip>
                    </div>
                    <v-layout v-else>
                      <v-flex d-block>
                        <p style="line-height: 70%">{{ data.item.Name }}<br>
                        <span style="font-size:10px; color:grey">{{data.item.Description}}</span></p>
                      </v-flex> 
                    </v-layout>
                  </template>
                </v-select>
              </v-flex>
              <v-flex v-if="categoryItems" :class="{'mx-5' : $vuetify.breakpoint.smAndUp}">
                <v-select
                  v-model="category"
                  :items="categoryItems"
                  :label="$t('equipment.addWorkRequests.category')"
                  item-text="Name"
                  item-value="Code"
                  :rules="[rules.required]"
                  :disabled="isInformationSecurity"
                ></v-select>
              </v-flex>
              <v-flex>
                <v-menu
                  :close-on-content-click="false"
                  v-model="menu"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="computedDateFormatted"
                    :label="$t('equipment.addWorkRequests.date')"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="date"
                    @input="menu2 = false"
                    :locale="$vuetify.t('$vuetify.datelocale')"
                    >
                    </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex :class="{'ml-5' : $vuetify.breakpoint.smAndUp}">
                <v-menu
                  :close-on-content-click="false"
                  v-model="endDateMenu"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="computedEndDateFormatted"
                    :label="$t('equipment.workRequests.endDate')"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>            
                  <v-date-picker
                    v-model="endDate"
                    :locale="$vuetify.t('$vuetify.datelocale')"
                    @change="endDateMenu = false"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12 offset-sm1 sm10>
              <v-textarea
                v-model="content"
                :label="$t('equipment.addWorkRequests.content')"
                :hint="$t('equipment.addWorkRequests.contentHint')"
                box
                @paste="onPasteImage"
                :rules="content.length ? [rules.length(10)] : []"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-form>
      </v-card-text>
      <v-card-actions :class="[$vuetify.breakpoint.xsOnly ? 'pa-0 mr-2 ml-2' : 'pa-0']">
        <v-layout pb-3 :class="{'d-block ma-0' : $vuetify.breakpoint.xsOnly}">
          <v-flex xs12 offset-sm1 sm2>
            <v-btn @click="pickFile" medium block>
              <v-icon dark>attach_file</v-icon>
              {{ $t('equipment.addWorkRequests.attachFile') }}
            </v-btn>
          </v-flex>
          <v-flex xs12 sm6 d-block>
            <v-chip v-for="n in imageFiles" :key="n.name" close @input="removeFile(n)">
              <v-avatar>
                <img :src="n.url" :alt="n.name" />
              </v-avatar>
              {{ n.name }}
            </v-chip>
            <input
              type="file"
              style="display: none"
              ref="image"
              accept="image/*,video/*"
              @change="onFilePicked"
              multiple
            />
          </v-flex>
          <v-flex xs12 sm2>
            <v-btn
              block
              medium
              :disabled="!form || !content"
              :loading="loading"
              class="white--text"
              :class="{'mt-3' : $vuetify.breakpoint.xsOnly}"
              color="green accent-4"
              @click="addWorkRequest()"
            >{{ $t(form && content ? 'equipment.addWorkRequests.add':'equipment.addWorkRequests.fillData') }}</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
    <v-snackbar v-model="snackbar" :color="snackbarColor" multi-line>
      {{ snackbarText }}
      <v-btn dark flat @click="snackbar = false">{{ $t('equipment.addWorkRequests.close') }}</v-btn>
    </v-snackbar>
  </v-container>
</template>


<script>
import { mapActions } from 'vuex'
import DateConverter from '@/utils/date-convert'

export default {
  name: 'AddWorkRequestForms',
  props: {
    equipmentId: String,
    equipmentResolution: {
      type: Boolean,
      default: false
    },
    onlyMy: {
      type: Boolean,
      default: true
    }
  },
  created() {
    if (this.$route.query.content) {
      this.content = this.$route.query.content
    }
    if (this.$route.query.category) {
      this.category = this.$route.query.category
    }
    if (this.$route.query.direction) {
      this.direction = this.$route.query.direction
    }
    if (this.$route.query.equipmentId) {
      this.onlyMyVal = false
      this.allEquip = false
    }
  },
  mounted() {
    if (!this.equipmentResolution) {
      this.updateAllEquipment({ onlyMy: this.onlyMy, skipCache: true })
      this.equipmentIdLocal = ''
    } else {
      this.equipmentIdLocal = this.equipmentId
    }
    this.updateDirectionsAndCategories()
  },
  data: vm => ({
    endDate: new Date(new Date().getTime() + 86400000*3).toISOString().substr(0, 10),
    endDateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    endDateMenu: false,
    equipmentIdLocal: '',
    direction: 'СС',
    category: '1IM',
    date: new Date().toISOString().substr(0, 10), 
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu: false,
    content: '',
    snackbar: false,
    form: false,
    allEquip: true,
    onlyMyVal: vm.onlyMy,
    rules: { 
      length: len => v =>
        (v || '').length >= len ||
        vm.$t('equipment.addWorkRequests.requiredLength', [len]),
      required: v => !!v || vm.$t('equipment.addWorkRequests.required')
    },
    imageFiles: [],
    search: '',
  }),
  methods: {
    ...mapActions([
      'updateAllEquipment',
      'updateDirectionsAndCategories'
    ]),
    findEquipmentId() {
      if (this.$route.query.equipmentId) {
        this.equipmentIdLocal = this.allEquipment.find(
          x => x.EquipmentId === this.$route.query.equipmentId
        )
      }
      if (!this.equipmentIdLocal && this.allEquip) {
        const workPlaceEquipment = this.allEquipment.find(x =>
          x.EquipmentId.startsWith('01.0')
        )
        if (workPlaceEquipment) {
          this.equipmentIdLocal = workPlaceEquipment.EquipmentId
        }
      }
    },
    updateAllEquipments() {
      this.updateAllEquipment({ skipCache: true, search: this.search && this.search.length ? this.search : null, })
    },
    addWorkRequest() {
      this.$store
        .dispatch('addWorkRequest', {
          params: {
            equipmentId: this.equipmentIdLocal,
            content: this.content,
            direction: this.direction,
            category: this.category,
            endDate: this.endDateFormatted
          },
          imageFiles: this.imageFiles
        })
        .then(() => {
          this.content = ''
          this.imageFiles = []
          if (!this.equipmentResolution) { this.updateAllEquipment({ onlyMy: this.allEquip, skipCache: true }) }
        })
    },
    formatDate(date) {
      return DateConverter.formatDate(date)
    },
    parseDate(date) {
      return DateConverter.parseDate(date)
    },
    pickFile() {
      this.$refs.image.click()
    },
    removeFile(file) {
      this.imageFiles.splice(this.imageFiles.indexOf(file), 1)
      this.imageFiles = [...this.imageFiles]
    },
    onFilePicked(e) {
      const files = e.target.files
      if (files) {
        for (let f = 0; f < files.length; f++) {
          const file = files[f]
          const fr = new FileReader()
          fr.readAsDataURL(file)
          fr.addEventListener('load', () => {
            this.imageFiles.push({
              name: file.name,
              url: fr.result,
              file: file
            })
          })
        }
      }
    },
    onPasteImage(event) {
      const items = (event.clipboardData || event.originalEvent.clipboardData)
        .items

      let file = null
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') === 0) {
          file = items[i].getAsFile()
        }
      }

      if (file !== null) {
        const reader = new FileReader()

        reader.readAsDataURL(file)
        reader.addEventListener('load', () => {
          this.imageFiles.push({
            name: this.imageFiles.length + '-' + file.name,
            url: reader.result,
            file: file
          })
        })
      }
    }
  },
  computed: {
    isInformationSecurity() {
      return this.direction == 'IS'
    },
    computedDateFormatted() {
      return this.formatDate(this.date)
    },
    computedEndDateFormatted() {
      return this.formatDate(this.endDate)
    },
    directionItems() {
      return this.$store.getters.workRequestDirections
    },
    categoryItems() {
      return this.$store.getters.workRequestCategories
    },
    loading() {
      return this.$store.state.base.loading
    },
    snackbarText() {
      return this.$store.state.snackbarText
    },
    snackbarColor() {
      return this.$store.state.snackbarColor
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    allEquipment() {
      return this.equipmentResolution ? [] : this.$store.getters.allEquipment
    },
    filteredEquipment() {
      return this.allEquipment.filter(e => {
        return Object.keys(this.filters).every(f => {
          return this.filters[f].length < 1 || this.filters[f].includes(e[f])
        })
      })
    },
    currentLocale() {
      return this.$store.getters.currentLocale
    }
  },
  watch: {
    equipmentId(value) {
      if (this.equipmentResolution && value) {
        this.equipmentIdLocal = value
      }
    },
    search(val){
      if( val && val.length >= 3) {
        this.updateAllEquipments(val)
      }
    },
    allEquip() {
      if ( this.allEquipment.find(
        x => x.EquipmentId === this.equipmentIdLocal
      )) {
        this.equipmentIdLocal = ''
      }
      if (!this.allEquip) {
        this.updateAllEquipment({ skipCache: true })
      } else {
        this.updateAllEquipment({ onlyMy: this.onlyMy, skipCache: true })
      }
      
    },
    allEquipment() {
      if (this.allEquipment && this.allEquipment.length) {
        this.findEquipmentId()
      }
    },
    date() {
      this.dateFormatted = this.formatDate(this.date)
    },
    endDate() {
      this.endDateFormatted = this.formatDate(this.endDate)
    },
    snackbarText(value) {
      if (value) {
        this.snackbar = true
      }
    },
    snackbar(value) {
      if (!value) {
        this.$store.commit('setSnackbarData', { color: '', text: '' })
      }
    }
  }
}
</script>
